import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Flex, IconFilePDF, Text } from '@zillow/constellation';
import { hasIncomeDocs } from './Description.utils';
import { useZgGraphqlQuery } from '../../../../../../../hooks/useGraphqlQuery';
import useQueryVariables from '../../../../../../../hooks/useQueryVariables';
import { useSelector } from 'react-redux';
import { getNeedsToIdVerifySelector } from '../../../../../../../selectors';
import { DESCRIPTION_QUERY } from '../../../../../../../constants/queries';
import { getTotalIncomeRollup } from '../../../../../ApplicationRollup/Household/Household.util';
import { IcraaComplianceContext } from '../../../../../../../contexts/IcraaComplianceContext';

export default function Description({ userId, zgAuthZone = '' }) {
  const { hasComplianceError } = useContext(IcraaComplianceContext);
  const needsToIdVerify = useSelector(getNeedsToIdVerifySelector());
  const { applicationId, propertyId: listingAlias } = useQueryVariables();
  const variables = {
    applicationId,
    listingAlias,
    applicantId: userId,
    zgAuthZone: zgAuthZone.toLowerCase(),
    needsToIdVerify,
  };
  const { data, isLoading } = useZgGraphqlQuery(DESCRIPTION_QUERY, variables);
  if (isLoading) {
    return null;
  }

  if (hasComplianceError) {
    return <Text>Report temporarily unavailable</Text>;
  }

  const incomeDocsAttached = hasIncomeDocs(data);
  const { applicant } = data.rentalListing.landlordRentalApplication;
  const totalMonthlyIncome = getTotalIncomeRollup([applicant], [], { includeSuffix: false });

  return (
    <div className="ApplicantSection__Row__Comment">
      <Flex display="flex" flexDirection="column">
        <Text className="nav-link__applicant__incomes">{`Total monthly income before taxes: ${totalMonthlyIncome}`}</Text>
        <Text className="nav-link__applicant__income_sources">{`Income sources: ${applicant.answers.currentIncomes.length}`}</Text>
        {incomeDocsAttached ? (
          <Flex display="flex" flexDirection="row">
            <IconFilePDF size="sm" fontColor="brand" marginRight="xxs" />
            <Text className="nav-link__applicant__incomeDocs" id={`${userId}-${zgAuthZone}-income-docs-attached`}>
              Income documents: Attached
            </Text>
          </Flex>
        ) : null}
      </Flex>
    </div>
  );
}

Description.propTypes = {
  userId: PropTypes.string.isRequired,
  zgAuthZone: PropTypes.string.isRequired,
};
